module.exports = __webpack_public_path__ + "img/loading5.c248cc5e.gif";